/**
 * parseCatalogCount (Story 32-3, AC #11)
 *
 * Parses the `catalogCount` search-param value — string OR number, depending
 * on the router's JSON-first search parsing — into a nonnegative integer.
 * NaN / negative / float / non-scalar garbage is dropped entirely (returns
 * undefined): the 31-29 callback contract is NON-FATAL, so malformed values
 * must never crash a route's validateSearch.
 *
 * Shared by the OAuth callback landing page and the client-detail route
 * (lives in lib/ — route modules participate in the routeTree.gen import
 * cycle and must not import each other; 32-1 learning).
 */
export function parseCatalogCount(value: unknown): number | undefined {
  const num =
    typeof value === "number"
      ? value
      : typeof value === "string"
        ? Number(value)
        : NaN;
  if (!Number.isInteger(num) || num < 0) return undefined;
  return num;
}
